module.exports = __webpack_public_path__ + "img/logo-scatbook-color.46946cc0.svg";